import { SidebarMenuSectionTitle } from '@styles/Layout/SidebarStyles';

interface ISidebarMenuSectionProps {
  title: string;
  children?: JSX.Element | JSX.Element[];
}

export const SidebarMenuSection = ({ title, children }: ISidebarMenuSectionProps) => (
  <>
    <SidebarMenuSectionTitle>{title}</SidebarMenuSectionTitle>
    {children}
  </>
);
